{
  "ipp-light": {
    "hero": {
      "eyebrow": "For small producers",
      "title": "Get the capital you need to expand your portfolio",
      "subtitle": "Collect in advance the profits your operating plants will generate over the coming years and use them today to grow your portfolio by building new assets."
    },
    "benefits": {
      "eyebrow": "The benefits",
      "heading": "A solution for producers seeking capital to build new plants",
      "items": [
        {
          "title": "Recover the capital locked in your operating assets",
          "body": "The DEC Energy solution lets you immediately collect up to 60% of the profits the plant will produce over the next 10 years."
        },
        {
          "title": "Finance the development of new projects",
          "body": "Immediately reuse the collected capital (no debt) to finance the development of new projects. Finding the equity to secure financing has never been this fast and convenient."
        },
        {
          "title": "Applicable to single plants, from 1 MWp",
          "body": "The most convenient ways to finance portfolio expansion are often out of reach because of high minimum volumes. The DEC Energy model instead lets producers with smaller plants grow their asset portfolio too."
        }
      ]
    },
    "stats": [
      {
        "target": "50-60",
        "suffix": "%",
        "label": "of future profits immediately"
      },
      {
        "target": "2-3",
        "suffix": "x",
        "label": "plants with the same equity"
      },
      {
        "target": 1,
        "suffix": "MWp",
        "label": "minimum plant size"
      }
    ],
    "caseReal": {
      "heading": "DEC Energy in numbers through a real case",
      "sub": "A producer and a manufacturing company are signing a deal on 5.24 MWp of photovoltaic assets",
      "parties": {
        "producer": "photovoltaic",
        "consumer": "manufacturing"
      },
      "spec": {
        "label": "Asset sheet",
        "rows": [
          { "label": "Peak power", "value": "5'235 kWp" },
          { "label": "Route-to-market", "value": "FER X" },
          { "label": "Energy sale price", "value": "63.97 €/MWh" },
          { "label": "OPEX", "value": "109'532 €/year" },
          { "label": "Debt %", "value": "75%" }
        ],
        "total": {
          "value": "1'383'766 €",
          "label": "Net cash flow over the next 10 years"
        }
      },
      "terms": {
        "label": "Contractual terms applied by DEC Energy",
        "items": [
          {
            "value": "710'000 €",
            "label": "Discounted amount, collected immediately"
          },
          {
            "value": "87.54%",
            "label": "Share of actual net cash flow to be distributed"
          },
          { "value": "10.64%", "label": "Discount rate" }
        ]
      }
    },
    "ctaTitle": "How much capital is locked in your plants?"
  },
  "ipp": {
    "hero": {
      "eyebrow": "For IPPs",
      "title": "Derisk your portfolio while increasing your IRR",
      "subtitle": "Reduce your portfolio's risk exposure by collecting today up to 50-60% of the next 10 years' net cash. No additional debt, no sale of your plants (or stakes in them)."
    },
    "benefits": {
      "eyebrow": "The benefits",
      "heading": "A solution for the most ambitious, forward-looking IPPs",
      "items": [
        {
          "title": "Better than mezzanine: convenient, fast, with no fixed repayment",
          "body": "The DEC Energy model discounts the future profits of operating plants. The solution also applies to single assets. The discount rate is performance-based and generally ranges between 7% and 13% depending on the asset."
        },
        {
          "title": "Collect now and reduce market and production risks",
          "body": "By contracting your plants, you immediately receive up to 50-60% of the net cash theoretically generated over the next 10 years. You secure part of the returns right away, eliminating price and production risks."
        },
        {
          "title": "Increase the IRR of your operation without additional investment",
          "body": "By discounting profits, you speed up the payback of most of the capital that would otherwise stay locked in the asset, and can allocate those funds to the development of new projects."
        }
      ]
    },
    "stats": [
      {
        "target": "50-60",
        "suffix": "%",
        "label": "of future net cash advanced"
      },
      {
        "target": 100,
        "suffix": "%",
        "label": "ownership retained"
      },
      {
        "target": "7-13",
        "suffix": "%",
        "label": "of discount rate"
      }
    ],
    "caseReal": {
      "heading": "DEC Energy in numbers through a real case",
      "sub": "An IPP and a chemical company are signing a deal on 13.67 MWp of photovoltaic asset",
      "parties": {
        "producer": "photovoltaic",
        "consumer": "Chemicals"
      },
      "spec": {
        "label": "Asset sheet",
        "rows": [
          { "label": "Total peak power", "value": "13.67 MWp" },
          { "label": "Route-to-market", "value": "FER X" },
          { "label": "Average energy sale price", "value": "65.78 €/MWh" },
          { "label": "OPEX", "value": "247'824 €/year" },
          { "label": "Debt %", "value": "80%" }
        ],
        "total": {
          "value": "2'583'434 €",
          "label": "Net cash flow over the next 10 years"
        }
      },
      "terms": {
        "label": "Contractual terms applied by DEC Energy",
        "items": [
          {
            "value": "1'370'000 €",
            "label": "Discounted amount, collected immediately"
          },
          {
            "value": "84.94%",
            "label": "Share of actual net cash flow to be distributed"
          },
          { "value": "9.43%", "label": "Discount rate" }
        ]
      }
    },
    "ctaTitle": "How much capital is locked in your operating assets?"
  },
  "utility": {
    "hero": {
      "eyebrow": "For utilities",
      "title": "Accelerate the transition while keeping ownership of your plants",
      "subtitle": "Get the capital you need to accelerate your independent energy transition. Without resorting to debt or selling your plants (or stakes in them)."
    },
    "benefits": {
      "eyebrow": "The benefits",
      "heading": "A solution for ambitious, sustainable utilities",
      "items": [
        {
          "title": "Keep full ownership of your plants",
          "body": "Apply the DEC Energy model to your operating plants to receive upfront cash without selling your assets."
        },
        {
          "title": "Increase your share of renewable production",
          "body": "Freely manage the production of the plants contracted with DEC Energy and use the unlocked capital to grow your renewable portfolio."
        },
        {
          "title": "Improve your Net Financial Position (NFP)",
          "body": "The capital obtained through DEC Energy is not financing, so it optimises your company's Net Financial Position (NFP)."
        }
      ]
    },
    "stats": [
      {
        "target": "50-60",
        "suffix": "%",
        "label": "of future net cash advanced"
      },
      {
        "target": 100,
        "suffix": "%",
        "label": "of ownership retained"
      },
      {
        "target": "No",
        "suffix": "",
        "label": "additional debt"
      }
    ],
    "caseReal": {
      "heading": "DEC Energy in numbers through a real case",
      "sub": "A utility and a foundry are signing a deal on 18.54 MWp of renewable asset",
      "parties": {
        "producer": "renewable asset",
        "consumer": "foundry"
      },
      "spec": {
        "label": "Asset sheet",
        "rows": [
          { "label": "Total peak power", "value": "18.54 MWp" },
          { "label": "Route-to-market", "value": "FER 1" },
          { "label": "Average energy sale price", "value": "73.84 €/MWh" },
          { "label": "OPEX", "value": "432'024 €/year" },
          { "label": "Debt %", "value": "80%" }
        ],
        "total": {
          "value": "3'968'166 €",
          "label": "Net cash flow over the next 10 years"
        }
      },
      "terms": {
        "label": "Contractual terms applied by DEC Energy",
        "items": [
          {
            "value": "2'150'000 €",
            "label": "Discounted amount, collected immediately"
          },
          {
            "value": "87.62%",
            "label": "Share of actual net cash flow to be distributed"
          },
          { "value": "9.47%", "label": "Discount rate" }
        ]
      }
    },
    "ctaTitle": "How much cash can you unlock without touching your NFP?"
  }
}
